export default __webpack_public_path__ + "static/media/ExamplePearCardBackground.5cab9242.png";